import fp from "lodash/fp";

import { dropdownValuesService } from "services";

export const loadBankRoutings = async (search, prevOptions, { page }) => {
	if (search.length < 3) {
		return {
			options: [],
		};
	} else {
		const body = {
			pattern: search,
			page,
			pageSize: 20,
		};

		const { items, count } = await dropdownValuesService.getBanks(body);
		const hasMore = prevOptions.length + items.length < count;
		const newBanks = fp.uniqBy("id", [...items]);

		if (fp.isEmpty(items)) {
			return {
				options: [
					{
						value: search,
						label: search,
					},
				],
			};
		} else {
			return {
				options: newBanks.map(b => ({
					value: b.routing,
					label: b.routing,
					bank: b.bank,
				})),
				hasMore,
				additional: {
					page: page + 1,
				},
			};
		}
	}
};
